import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  plus20p0vtfmu0596 as plus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  addAll1k27qatfgp3k5 as addAll,
  removeLastOrNull3odnlbetbttd4 as removeLastOrNull,
  removeLast3759euu1xvfa3 as removeLast,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { overlayWriter1bxnhxr8o82ue as overlayWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.commonHtml.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_scrolling27q1yr4ng0cx8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Direct1onk7bpgb7kpa as Direct,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { asReversed2y2qzr7vrqd5 as asReversed } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NavigatorClass;
function Navigator() {
  if (NavigatorClass === VOID) {
    class $ {
      constructor(pages, close) {
        this.mj7_1 = pages;
        this.nj7_1 = close;
      }
    }
    initMetadataForClass($, 'Navigator');
    NavigatorClass = $;
  }
  return NavigatorClass;
}
var DialogHandler$dialog$lambda$slambdaClass;
function DialogHandler$dialog$lambda$slambda() {
  if (DialogHandler$dialog$lambda$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DialogHandler$dialog$lambda$slambdaClass = $;
  }
  return DialogHandler$dialog$lambda$slambdaClass;
}
function DialogHandler$dialog$lambda$slambda_0() {
  var i = new (DialogHandler$dialog$lambda$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var DialogHandler$dialog$lambda$slambdaClass_0;
function DialogHandler$dialog$lambda$slambda_1() {
  if (DialogHandler$dialog$lambda$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        return Unit_instance;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DialogHandler$dialog$lambda$slambdaClass_0 = $;
  }
  return DialogHandler$dialog$lambda$slambdaClass_0;
}
function DialogHandler$dialog$lambda$slambda_2() {
  var i = new (DialogHandler$dialog$lambda$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function DialogHandler$close$ref(p0) {
  var l = () => {
    p0.kcr();
    return Unit_instance;
  };
  l.callableName = 'close';
  return l;
}
var DialogHandlerClass;
function DialogHandler() {
  if (DialogHandlerClass === VOID) {
    class $ {
      constructor(overlay) {
        this.jgd_1 = overlay;
        this.kgd_1 = ReactiveMutableList().tam();
        var tmp = this;
        tmp.lgd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = $this$remember.baj(this.kgd_1);
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = lastOrNull($this$remember.baj(element.mj7_1));
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver);
            }
          }
          return destination;
        });
        var tmp_0 = this;
        tmp_0.mgd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = $this$remember.baj(this.kgd_1);
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var list = $this$remember.baj(element.mj7_1);
            addAll(destination, list);
          }
          return destination;
        });
      }
      xgd(page) {
        overlayWriter(this.jgd_1, VOID, VOID, ($this$overlayWriter, remover) => {
          var nav = new (Navigator())(ReactiveMutableList().vam([page]), remover);
          this.kgd_1.lam(nav);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())($this$overlayWriter.pc());
          var tmp0_elvis_lhs = $this$overlayWriter.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$overlayWriter : tmp0_elvis_lhs;
          $this$overlayWriter.ebb(p, view);
          var $this$frame = view;
          reactive($this$frame, ($this$reactive) => {
            $this$frame.zb9();
            var tmp0_safe_receiver = lastOrNull($this$reactive.baj(nav.mj7_1));
            return tmp0_safe_receiver == null ? null : render(tmp0_safe_receiver, $this$frame);
          });
          $this$overlayWriter.fbb(p, view);
          return Unit_instance;
        });
      }
      oj7(allowDismiss, scrolling, render) {
        this.xgd(new (Direct())(VOID, ($this$Direct) => {
          var tmp = scrolling ? get_scrolling($this$Direct) : Companion_getInstance();
          // Inline function 'com.crowpay.views.components.dismissBackground2' call
          // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (DismissBackground())($this$Direct.pc());
          var tmp0_elvis_lhs = $this$Direct.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$Direct : tmp0_elvis_lhs;
          $this$Direct.ebb(p, view);
          view.tbo(DialogHandler$dialog$lambda$slambda_0());
          if (!allowDismiss) {
            view.tbo(DialogHandler$dialog$lambda$slambda_2());
          }
          view.eba(get_AppDimensions().wg1_1);
          var tmp_0 = view.ibb(scrolling ? get_atTopCenter(view) : get_centered(view), view.hbb(DialogSemantic_getInstance()));
          view.jbb(tmp_0, render(view, DialogHandler$close$ref(this)));
          $this$Direct.fbb(p, view);
          return $this$Direct.jbb(tmp, view);
        }));
      }
      th2(allowDismiss, scrolling, render, $super) {
        allowDismiss = allowDismiss === VOID ? true : allowDismiss;
        scrolling = scrolling === VOID ? false : scrolling;
        var tmp;
        if ($super === VOID) {
          this.oj7(allowDismiss, scrolling, render);
          tmp = Unit_instance;
        } else {
          tmp = $super.oj7.call(this, allowDismiss, scrolling, render);
        }
        return tmp;
      }
      dbw(page) {
        var tmp0_safe_receiver = lastOrNull(this.kgd_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var _receiver__tnumb7 = tmp0_safe_receiver.mj7_1;
          _receiver__tnumb7.wam(plus(_receiver__tnumb7.f2(), page));
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this.xgd(page);
        }
      }
      kcr() {
        var tmp0_safe_receiver = removeLastOrNull(this.kgd_1);
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver.nj7_1();
      }
      ngd() {
        var tmp0_safe_receiver = lastOrNull(this.kgd_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp;
          if (tmp0_safe_receiver.mj7_1.p1() <= 1) {
            tmp0_safe_receiver.nj7_1();
            tmp = removeLast(this.kgd_1);
          } else {
            tmp = removeLastOrNull(tmp0_safe_receiver.mj7_1);
          }
        }
      }
      ugg() {
        var _iterator__ex2g4s = asReversed(this.kgd_1).m1();
        while (_iterator__ex2g4s.n1()) {
          var n = _iterator__ex2g4s.o1();
          n.nj7_1();
        }
        this.kgd_1.v3();
      }
      nd6(page) {
        var tmp0_safe_receiver = lastOrNull(this.kgd_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp;
          if (tmp0_safe_receiver.mj7_1.i1()) {
            tmp = tmp0_safe_receiver.mj7_1.lam(page);
          } else {
            tmp0_safe_receiver.mj7_1.fm(get_lastIndex(tmp0_safe_receiver.mj7_1), page);
            tmp = Unit_instance;
          }
        }
      }
      ebw(page) {
        this.ugg();
        this.xgd(page);
      }
    }
    initMetadataForClass($, 'DialogHandler');
    DialogHandlerClass = $;
  }
  return DialogHandlerClass;
}
function render_0(_this__u8e3s4) {
  return lastOrNull(get_mainPageNavigator(_this__u8e3s4).gbn_1.f2()) === this ? this.vgs(_this__u8e3s4) : this.wgs(_this__u8e3s4);
}
var DialogOrPageClass;
function DialogOrPage() {
  if (DialogOrPageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DialogOrPage', VOID, VOID, [Page()]);
    DialogOrPageClass = $;
  }
  return DialogOrPageClass;
}
function exit(page, _this__u8e3s4) {
  get_dialogStack().ugg();
  if (lastOrNull(get_mainPageNavigator(_this__u8e3s4).gbn_1.f2()) === page) {
    get_mainPageNavigator(_this__u8e3s4).rd6();
  }
}
var HasFallbackClass;
function HasFallback() {
  if (HasFallbackClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HasFallback');
    HasFallbackClass = $;
  }
  return HasFallbackClass;
}
//region block: exports
export {
  DialogHandler as DialogHandler190bym9acvxfj,
  render_0 as render1ekxzgt3v21h2,
  DialogOrPage as DialogOrPageiidrs19hacf7,
  HasFallback as HasFallback3lthr8mgiugg2,
  exit as exit12upnsqp8029y,
};
//endregion

//# sourceMappingURL=DialogWithDialog.mjs.map
